export default {
  workstation: {
    tabs: {
      workstation: "Estação de trabalho",
    },
    filters: {
      withAll: "Com todos",
      withoutAny: "Sem nenhum",
      withPlayer: "Com {{player}}",
      withoutPlayer: "Sem {{player}}",
      all: "Todos",
      versusPosition: "vs {{position}}",
      starter: "Titular",
      nonStarter: "Não titular",
      starterAndNonStarter: "Titular + não titular",
      betType: "Tipo de aposta",
      timeframe: "Período",
      splits: "Divisões",
      with: "Com",
      without: "Sem",
      opponent: "Adversário",
    },
    actions: {
      applyFilter: "Aplicar filtro",
      applied: "Aplicado",
    },
    banners: {
      notPlayingToday: "{{entity}} não joga hoje",
    },
    sections: {
      stats: "Estatísticas",
      seasonStats: "Estatísticas da temporada",
      last3Seasons: "Últimas 3 temporadas",
      batterVsPitcherGamelog: "Ver histórico rebatedor vs. arremessador",
    },
    stats: {
      perGame: "Por jogo",
      total: "Total",
      timeframe: "Período",
      filters: "Filtros",
      season: "Temporada",
    },
    headers: {
      type: "Tipo",
      hitRate: "Taxa de acerto",
      odds: "Odds",
      stat: "Stat",
      average: "Média",
    },
    outcomes: {
      covered: "Cobriu",
      yes: "Sim",
      no: "Não",
      win: "W",
      loss: "L",
      tie: "TIE",
    },
    alerts: {
      imageSavedToDevice: "Imagem salva no dispositivo",
    },
  },
};
